interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const getSchema = () => {
    const base = { '@context': 'https://schema.org', '@type': type };

    switch (type) {
      case 'Organization':
        return {
          ...base,
          name: '俄罗斯妈妈',
          url: 'https://russianmama.cn',
          description: '走进真实的俄罗斯妈妈世界，探索俄罗斯妈妈的真实生活、育儿理念与家庭文化。',
          sameAs: ['https://weibo.com/russianmama', 'https://weixin.qq.com/russianmama'],
          ...data,
        };

      case 'WebSite':
        return {
          ...base,
          name: '俄罗斯妈妈',
          url: 'https://russianmama.cn',
          description: '探索俄罗斯妈妈的真实生活、育儿理念与家庭文化',
          inLanguage: 'zh-CN',
          ...data,
        };

      case 'WebPage':
        return {
          ...base,
          name: data.name || '俄罗斯妈妈',
          description: data.description || '探索俄罗斯妈妈的真实生活、育儿理念与家庭文化',
          inLanguage: 'zh-CN',
          isPartOf: {
            '@type': 'WebSite',
            name: '俄罗斯妈妈',
            url: 'https://russianmama.cn',
          },
          ...data,
        };

      case 'Article':
        return {
          ...base,
          headline: data.headline || '',
          description: data.description || '',
          image: data.image || '',
          author: {
            '@type': 'Person',
            name: data.author || '俄罗斯妈妈',
          },
          datePublished: data.datePublished || '',
          dateModified: data.dateModified || data.datePublished || '',
          publisher: {
            '@type': 'Organization',
            name: '俄罗斯妈妈',
          },
          inLanguage: 'zh-CN',
          ...data,
        };

      case 'FAQPage':
        return {
          ...base,
          mainEntity: (data.questions as Array<{ question: string; answer: string }>)?.map((q) => ({
            '@type': 'Question',
            name: q.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: q.answer,
            },
          })) || [],
          ...data,
        };

      default:
        return base;
    }
  };

  return <script type="application/ld+json">{JSON.stringify(getSchema())}</script>;
}